import React, { useMemo } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { colors } from "@zapalacorp/tokens";

import { BannerText, WrapperBanner } from "./styles";

interface BannerProps {
  title?: string;
  text: string;

  variant?: string;
}

export const BannerComponent = (props: BannerProps) => {
  const { title, text, variant } = props;

  const { iconColor, textColor, ...rest } = useMemo(() => {
    switch (variant) {
      case "warning":
        return {
          backgroundColor: colors.warning50,
          borderColor: colors.warning200,
          textColor: colors.warning700,
          iconColor: colors.warning700,
        };
      default:
        return {
          backgroundColor: colors.brandBlue50,
          borderColor: colors.brandBlue200,
          textColor: colors.brandBlue700,
          iconColor: colors.brandBlue700,
        };
    }
  }, [variant]);

  return (
    <WrapperBanner {...rest}>
      <div>
        <AiOutlineInfoCircle size={20} color={iconColor} />
      </div>
      <BannerText textColor={textColor}>
        {title && <b>{title}: </b>}
        {text}
      </BannerText>
    </WrapperBanner>
  );
};
